var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-item"},[_c('div',{staticClass:"time-hms"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"time-ymd"},[_vm._v(_vm._s(_vm.day))])])
}
var staticRenderFns = []

export { render, staticRenderFns }